<h2 mat-dialog-title>{{'advancedSettings' | translate}}</h2>

<mat-dialog-content class="content-type-settings-content">
  <form [formGroup]="contentForm" class="settings-form mt-2">
    <section class="settings-section">
      <div class="section-copy">
        <h3>{{'contentTypes.basicData' | translate}}</h3>
        <p>{{'contentTypes.basicDataDescription' | translate}}</p>
      </div>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.name' | translate}}</mat-label>
        <input matInput type="text" formControlName="displayName" id="inputDisplayName" name="displayName" placeholder="{{'contentTypes.name' | translate}}" data-nar="content-type-edit-name">
      </mat-form-field>
    </section>

    <section class="settings-section">
      <div class="section-copy">
        <h3>{{'contentTypes.structureAndDisplay' | translate}}</h3>
        <p>{{'contentTypes.structureAndDisplayDescription' | translate}}</p>
      </div>

      <div class="settings-action-grid">
        <button type="button" class="settings-action-card" (click)="openSchemaView()" data-nar="content-type-edit-schema">
          <span class="action-icon"><mat-icon>account_tree</mat-icon></span>
          <span>
            <strong>{{'contentTypes.editSchema' | translate}}</strong>
            <small>{{'contentTypes.editSchemaDescription' | translate}}</small>
          </span>
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button type="button" class="settings-action-card" (click)="openDisplayTemplateView()">
          <span class="action-icon"><mat-icon>book_online</mat-icon></span>
          <span>
            <strong>{{'contentTypes.displayTemplate' | translate}}</strong>
            <small>{{'contentTypes.displayTemplateDescription' | translate}}</small>
          </span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </section>

    <section class="settings-section">
      <div class="section-copy">
        <h3>{{'contentTypes.data_validation' | translate}}</h3>
        <p>{{'contentTypes.data_validation_explanation' | translate}}</p>
      </div>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.data_validation' | translate}}</mat-label>
        <mat-select formControlName="schemaMode" id="schemaMode" name="schemaMode">
          <mat-option value="none">{{'contentTypes.none' | translate}}</mat-option>
          <mat-option value="warning">{{'contentTypes.warning' | translate}}</mat-option>
          <mat-option value="error">{{'contentTypes.error' | translate}}</mat-option>
        </mat-select>
        <mat-hint>{{'contentTypes.data_validation_explanation' | translate}}</mat-hint>
      </mat-form-field>
    </section>

    <section class="settings-section">
      <div class="section-copy">
        <h3>{{'contentTypes.title_key' | translate}}</h3>
        <p>{{'contentTypes.titleKeyDescription' | translate}}</p>
      </div>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.title_key' | translate}}</mat-label>
        <input matInput type="text" formControlName="titleKey" id="titleKey" placeholder="{{'contentTypes.title_key' | translate}}" data-nar="content-type-edit-title" (focus)="setActiveTitleKey()">
        @if (availableSubtitleKeys.length) {
          <button type="button" mat-icon-button matSuffix [matMenuTriggerFor]="titleKeyMenu" (click)="setActiveTitleKey()">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
      </mat-form-field>

      <mat-menu #titleKeyMenu="matMenu">
        <button mat-menu-item type="button" [matMenuTriggerFor]="subtitleSchemaMenu">
          <mat-icon>account_tree</mat-icon>
          <span>{{'contentTypes.insertFromSchema' | translate}}</span>
        </button>
      </mat-menu>
    </section>

    <section class="settings-section">
      <div class="section-copy">
        <h3>{{'pass.subtitle' | translate}}</h3>
        <p>{{'contentTypes.subtitleKeysDescription' | translate}}</p>
      </div>
      <div class="mt-4">
        @for (subtitle of subtitleKeys; track subtitle; let index = $index) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'contentTypes.subtitle_key' | translate }} {{ index + 1 }}</mat-label>
            <input matInput type="text" [formControl]="getSubtitleControl(index)" (focus)="setActiveSubtitle(index)">
            <button type="button" mat-icon-button matSuffix [matMenuTriggerFor]="subtitleMenu" (click)="setActiveSubtitle(index)">
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-form-field>
        }
      </div>

      <mat-menu #subtitleMenu="matMenu" class="subtitle-action-menu">
        @if (availableSubtitleKeys.length) {
          <button mat-menu-item type="button" [matMenuTriggerFor]="subtitleSchemaMenu">
            <mat-icon>account_tree</mat-icon>
            <span>{{'contentTypes.insertFromSchema' | translate}}</span>
          </button>
          <mat-divider></mat-divider>
        }
        <button mat-menu-item type="button" class="danger-menu-item" (click)="deleteSubtitleKey(activeSubtitleIndex)" [disabled]="!contentTypeUserRights_update || !subtitleKeys.length">
          <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
          <span>{{'delete' | translate}}</span>
        </button>
      </mat-menu>

      <mat-menu #subtitleSchemaMenu="matMenu" class="subtitle-key-menu">
        @for (key of availableSubtitleKeys; track key) {
          <button mat-menu-item type="button" (click)="insertSubtitleKey(key)" [disabled]="!contentTypeUserRights_update">
            <span>{{key}}</span>
          </button>
        }
      </mat-menu>

      <button type="button" mat-button class="secondary-gray-button" id="btn-add" (click)="addSubtitleKey();">
        <mat-icon>add_circle</mat-icon> {{'contentTypes.add_subtitle' | translate}}
      </button>
    </section>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="settings-actions">
  <button mat-button style="color:var(--warmOrange);" (click)="cancelEditContentType();">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="saveEditContentType();">{{'save' | translate}}</button>
</mat-dialog-actions>
